<template>
  <label for="checked" class="mt-1 inline-flex items-center cursor-pointer">
    <span class="relative">
      <span class="block w-10 h-6 bg-gray-400 rounded-full shadow-inner"></span>
      <span
        class="absolute block w-4 h-4 mt-1 ml-1 rounded-full shadow inset-y-0 left-0 focus-within:shadow-outline transition-transform duration-300 ease-in-out"
        :class="[ toggleStatus ? 'bg-blue-700 transform translate-x-full' : 'bg-white' ]"
      >
        <input id="checked" type="checkbox" class="absolute opacity-0 w-0 h-0" v-model="toggleStatus" @change="$emit('toggle', toggleStatus)"/>
      </span>
    </span>
    <span class="ml-3 text-sm" v-if="displayText">{{ toggleStatus ? onText : offText }}</span>
  </label>
</template>

<script>
export default {
  props: {
    displayText: { type: Boolean, default: false },
    offText: { type: String, default: 'false' },
    onText: { type: String, default: 'true' },
    status: Boolean
  },
  model: {
    prop: 'status',
    event: 'toggle'
  },
  data () {
    return {
      toggleStatus: this.status
    }
  }
}
</script>
